"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _utils = require("../assets/utils");
var CancellationStageListItem = function CancellationStageListItem(props) {
  var _props$price = props.price,
    price = _props$price === void 0 ? 0 : _props$price,
    interval = props.interval,
    returnType = props.returnType,
    flightDateISO = props.flightDateISO,
    first = props.first,
    isHotelOnly = props.isHotelOnly,
    _props$isMobilePopupC = props.isMobilePopupComponent,
    isMobilePopupComponent = _props$isMobilePopupC === void 0 ? false : _props$isMobilePopupC;
  var fullReturn = (0, _utils.isFullReturn)(returnType);
  var priceText = (0, _utils.getPriceText)(price, fullReturn);
  var text = isHotelOnly ? (0, _utils.getDescriptionStagesText)(price, interval, fullReturn, isHotelOnly) : (0, _utils.getReturnText)(price, interval, fullReturn, isHotelOnly);
  var datesText = (0, _utils.getListItemDateText)(interval, flightDateISO, isHotelOnly, first);
  return /*#__PURE__*/_react["default"].createElement(StyledCancellationStageListItem, null, /*#__PURE__*/_react["default"].createElement(StyledTitleRow, {
    isMobilePopupComponent: isMobilePopupComponent
  }, /*#__PURE__*/_react["default"].createElement(StyledTitle, null, priceText), /*#__PURE__*/_react["default"].createElement(StyledDates, null, datesText)), /*#__PURE__*/_react["default"].createElement(StyledDescription, {
    isMobilePopupComponent: isMobilePopupComponent
  }, text));
};
var StyledCancellationStageListItem = _styledComponents["default"].div.withConfig({
  displayName: "CancellationStageListItem__StyledCancellationStageListItem",
  componentId: "sc-1vl9owf-0"
})(["margin-top:16px;display:block;flex-direction:column;"]);
var StyledTitleRow = _styledComponents["default"].div.withConfig({
  displayName: "CancellationStageListItem__StyledTitleRow",
  componentId: "sc-1vl9owf-1"
})(["display:flex;flex-direction:row;align-items:center;div + div{margin-left:8px;}font-size:", "px;"], function (_ref) {
  var isMobilePopupComponent = _ref.isMobilePopupComponent;
  return isMobilePopupComponent ? '15' : '12';
});
var StyledDescription = _styledComponents["default"].div.withConfig({
  displayName: "CancellationStageListItem__StyledDescription",
  componentId: "sc-1vl9owf-2"
})(["line-height:16px;color:", ";font-size:", "px;"], function (_ref2) {
  var theme = _ref2.theme;
  return theme.colors.blackLight;
}, function (_ref3) {
  var isMobilePopupComponent = _ref3.isMobilePopupComponent;
  return isMobilePopupComponent ? '13' : '12';
});
var StyledTitle = _styledComponents["default"].div.withConfig({
  displayName: "CancellationStageListItem__StyledTitle",
  componentId: "sc-1vl9owf-3"
})(["font-weight:bold;line-height:16px;color:", ";"], function (_ref4) {
  var theme = _ref4.theme;
  return theme.colors.blackLight;
});
var StyledDates = _styledComponents["default"].div.withConfig({
  displayName: "CancellationStageListItem__StyledDates",
  componentId: "sc-1vl9owf-4"
})(["line-height:16px;color:", ";"], function (_ref5) {
  var theme = _ref5.theme;
  return theme.colors.greyLight;
});
var _default = exports["default"] = /*#__PURE__*/_react["default"].memo(CancellationStageListItem);